import { DocumentNode, gql } from '@apollo/client';

export const GetPortfolioData: DocumentNode = gql`
    query GetPortfolioData($input: PortfolioDataInput!) {
        getPortfolioData(input: $input) {
            seriesData {
                date
                value
            }
        }
    }
`;
